import {
  Button,
  useTheme
} from '@mui/material';
import { useParams } from 'react-router-dom';

import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  MarkInstallationAsInstalledModal,
  SaveInstallationModal,
  RemoveInstallationModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithFIlterLayout } from 'modules/components/layer32';
import React, { useState } from 'react';

import * as ds from './dataService';

export type ProjectInstallationHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectInstallationHeaderSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.installationId ?? '');
  return (
    <ActivityHeaderSectionWithFIlterLayout.FC
      filterRow={(<></>)}
      actionButtons={(
        <ActionButtonsGroup
          id={params.installationId ?? ''}
          isComplete={data.isComplete}
        />
      )}
      title={data?.name ?? ''}
      subtitle={data.type}
      backButton={true}
    />
  );
};


type ActionButtonsGroup = {
  isComplete: boolean;
  id: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isDeleteVisible,
    setIsDeleteVisible
  ] = useState(false);
  const access = useAccessState('Installation');

  const [
    isCompleteVisible,
    setIsCompleteVisible
  ] = useState(false);


  const theme = useTheme();

  return (
    <>
      {isVisible && (
        <SaveInstallationModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id={props.id ?? ''}
        />
      )}
      {isCompleteVisible && (
        <MarkInstallationAsInstalledModal.FC
          isVisible={isCompleteVisible}
          isComplete={props.isComplete}
          handleClose={() => setIsCompleteVisible(() => false)}
          id={props.id ?? ''}
        />
      )}
      {isDeleteVisible && (
        <RemoveInstallationModal.FC
          isVisible={isDeleteVisible}
          handleClose={() => setIsDeleteVisible(() => false)}
          id={props.id ?? ''}
        />
      )}
      <Button
        variant='outlined'
        color='error'
        disabled={props.isComplete || !access.create}
        onClick={() => {
          setIsDeleteVisible(() => true);
        }}
        startIcon={(
          <CustomIcon.large.FC
            icon='DELETE'
            stroke={props.isComplete ? theme.palette.error.light : theme.palette.error.main}
          />
        )}
      >
        Remove Finish
      </Button>


      <Button
        onClick={() => {
          setIsVisible(() => true);
        }}
        variant='outlined'
        disabled={props.isComplete || !access.update}
        startIcon={(
          <CustomIcon.large.FC
            icon='EDITALT'
            stroke={props.isComplete ? theme.palette.primary.light : theme.palette.primary.main}
          />
        )}
      >
        Edit
      </Button>
      <Button
        variant='contained'
        disabled={!access.update}
        onClick={() => setIsCompleteVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='CHECKFLAT'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        {
          props.isComplete
            ? 'Mark As Todo'
            : 'Mark As Installed'
        }
      </Button>
    </>
  );
};

